import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from 'cbc-shared-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { sgkz001dConfig } from '../../../../config/sgkz001d-config';
import { SideMenuService } from '../../../../sg-base/sg-base-shared/services/side-menu.service';

/**
 * メニュー画面
 * @export
 * @class MenuComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {

  /** configファイルに定義しているサイドメニュー要素のList */
  dtoList: any[] = [];

  /** TOPタイトルとItemIdのMap */
  titleAndTopItemIdMap: Map<string, string> = new Map<string, string>();

  /** 購読停止用Subject */
  private onDestroy$ = new Subject();

  /**
   * コンストラクタ
   * @param {AuthService} authService
   * @param {Router} router
   * @memberof MenuComponent
   */
  constructor(private authService: AuthService, private router: Router, private sideMenuService: SideMenuService) { }

  /**
   * 初期化処理
   * @memberof MenuComponent
   */
  ngOnInit(): void {
    this.dtoList = sgkz001dConfig;

    this.sideMenuService.getTitleAndTopItemIdMap.pipe(takeUntil(this.onDestroy$)).subscribe(titleAndTopItemIdMap => {
      this.titleAndTopItemIdMap = titleAndTopItemIdMap;
    });
  }

  /**
   * ログアウト処理
   * @memberof MenuComponent
   */
  logout(): void {
    if (this.authService.isAuthenticated()) {
      this.authService.logout(false);
    } else {
      this.router.navigate(['/login']);
    }
  }

  /**
   * TOPのItemId取得
   * @memberof MenuComponent
   */
  getTopItemId(title: string): string {
    return this.titleAndTopItemIdMap.get(title);
  }
}
